import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import AssignmentPolicyEditorPanel from '../../../assignmentPolicy/AssignmentPolicyEditorPanel';
import SidebarContainer, {
  SidebarContainerProps,
} from '../../../containers/SidebarContainer';
import ProximityPolicyEditorPanel from '../../../proximityPolicy/ProximityPolicyEditorPanel';
import { simulationStorageTabKey } from '../../store/simulation.wizard.state';

export default () => {
  const { t } = useTranslation('simulation');
  const selectedTab = useRecoilValue(simulationStorageTabKey);
  const containerProps: SidebarContainerProps = {
    type: 'sidebar-policy-storage-editor',
    title: t`Filter Policy Params`,
    loadingMessage: t`Loading Policy...`,
    size: 'xs',
  };

  return (
    <SidebarContainer
      data-component="AssignmentPolicyEditorSidebar"
      key={containerProps.type}
      {...containerProps}
    >
      {selectedTab === 'tab-policy-assignment' && (
        <AssignmentPolicyEditorPanel />
      )}
      {selectedTab === 'tab-policy-proximity' && <ProximityPolicyEditorPanel />}
    </SidebarContainer>
  );
};
